module.exports = __webpack_public_path__ + "static/pic03-75eb362e78bd9e0bf3fe4fa4b1feb994.jpg";